<template>
 <div class="method_continer">
    <!-- <div class="method_1">
      <div style="display:flex;align-items:center;justify-content: center;margin-bottom:1.1vh;">
        <img style="height:4vh;width:4vh;margin-right:1.1vh" src="./../../assets/method1.png" alt="SVG图形">
        <span class="method_title">核算方法 </span></div>
      <div class="method_item">{{item1}}</div>
      <div style="display:flex; position: relative;height:6.6vh">
      <div class="method_item">核算方法：</div>
      <div style="top:2vh;width:100%;font-size:2.6vh;font-weight:550;letter-spacing: 0.1em;color: #1d466b;">排放因子 ✖ 活动水平</div>
      </div>
    </div> -->
    <div style="display:flex;width:100%;align-items: center;justify-content: center;margin-bottom:5vh;">
      <div class="method_2"  :style="{ backgroundImage: 'url(' + require('./../../assets/method/back1.png') + ')',backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }">
        <div style="display:flex;align-items:center;margin-bottom: 3vh;">
        <div class="method_img"><img style="height:3.5vh;width:3.5vh;" src="./../../assets/method2.png" alt="SVG图形"></div>
        <span class="method_title2">核算边界</span></div>
        <div style="  bottom: 4vh;left: 4vh;">
          <div class="method_item" >{{item1}}</div>
        </div>
      </div>
      <div style="width:4%"></div>
      <div class="method_2" :style="{ backgroundImage: 'url(' + require('./../../assets/method/back2.png') + ')',backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'  }">
        <div style="display:flex;align-items:center;margin-bottom: 3vh;">
        <div class="method_img"><img style="height:3.5vh;width:3.5vh;" src="./../../assets/method1.png" alt="SVG图形"></div>
        <span class="method_title2">核算方法</span></div>
        <div style=" bottom:4vh; left:4vh;">
           <div class="method_item3">{{item2[0]}}</div>
          <div class="method_item3" >{{item2[1]}}</div>
        </div>
       
      </div>
    </div>
      <div style="display:flex;width:100%;align-items: center;justify-content: center;margin-bottom:5.5vh;">
      <div class="method_2" :style="{ backgroundImage: 'url(' + require('./../../assets/method/back2.png') + ')',backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'  }">
        <div style="display:flex;align-items:center;margin-bottom: 3vh;">
        <div class="method_img"><img style="height:3.5vh;width:3.5vh;" src="./../../assets/method2.png" alt="SVG图形"></div>
        <span class="method_title2">功能单位</span></div>
        <div style="  bottom: 4vh;left: 4vh;">
          <div class="method_item3">单位面积碳足迹（t CO<sub>2</sub>e/hm<sup>2</sup>）</div>
          <div class="method_item3">单位产量碳足迹（kg CO<sub>2</sub>e/kg）</div>
        </div>
      </div>
      <div style="width:4%"></div>
      <div class="method_2" :style="{ backgroundImage: 'url(' + require('./../../assets/method/back1.png') + ')',backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'  }">
        <div style="display:flex;align-items:center;margin-bottom: 3vh;">
        <div class="method_img"><img style="height:3.5vh;width:3.5vh;" src="./../../assets/method3.png" alt="SVG图形"></div>
        <span class="method_title2">数据来源</span></div>
        <div style="  bottom: 4vh;left: 4vh;">
          <div class="method_item3">{{item3[0]}}</div>
          <div class="method_item3">{{item3[1]}}</div>
          <div class="method_item3">{{item3[2]}}</div>
        </div>
      </div>
    </div>
    <!-- <div class="method_1" style="margin-top:6.6vh;">
      <div style="display:flex;align-items:center;justify-content: center;margin-bottom:1.1vh;">
        <img style="height:4.4vh;width:4.4vh;margin-right:1.1vh" src="./../../assets/method3.png" alt="SVG图形">
        <span class="method_title">数据来源</span></div>
      <div class="method_item">
      <span class="method_item">{{item3[0]}}</span>
      <span class="method_item3">{{item3[1]}}</span>
      <span class="method_item">{{item3[2]}}</span>
      <span class="method_item3">{{item3[3]}}</span>
      <span class="method_item">{{item3[4]}}</span>
      <a href="http://www.chinapower.com.cn/sj/" target="_blank"><span class="method_item3">{{item3[5]}}</span></a></div>
    </div> -->
  </div>
</template>

<script>

export default {
  name: 'MethodView',
   components: {

  },
  data(){
    return{
      item1:"采用生命周期法（LCA）评价农产品碳足迹。农产品碳足迹的系统边界为“摇篮到大门”，即作物从播种到收获过程中各项活动产生的温室气体排放，包括化肥生产、氮肥田间施用、农药生产、农膜生产、农机耗能、灌溉用电等。",
      item2:["核算方法采用IPCC推荐的温室气体清单法","排放因子✖活动水平",],
      item3:["《全国农产品成本收益资料汇编》",
      "《中国农村统计年鉴》",
      "《中国物价年鉴》",],
      item4:["单位面积碳足迹（t CO2eq·hm-2）","单位产量碳足迹（kg CO2eq·kg-1）"]
    }
  }
}
</script>


<style>
.method_img{
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5vh;
  height: 5vh;
  margin-right: 2vh;
  border-radius: 1vh;
}
.method_continer{
  
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f0f0f4;
  padding: 4vh 0 0 0;
}
.method_1{
  width: 70%;
  background-color: #fff;
  border-radius: 30px;
  position: relative;
  padding: 15px 40px;
  box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.5); /* 主阴影 */
  transform: rotateY(10deg); /* 绕Y轴旋转10度 */
}
.method_2{
  position: relative;
  width: 28%;
  padding: 4vh 4vh;
  min-height: 25vh;
  background-color: #fff;
  border-radius: 30px;
  position: relative;
  /* padding: 15px; */
  box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.5); /* 主阴影 */
  transform: rotateY(10deg); /* 绕Y轴旋转10度 */
}
.method_title{
  font-size: 3.2vh;
  color: #ffffff;
  font-weight: 900;
  letter-spacing: 0.2em;
  
}
.method_title2{
  font-size: 2.7vh;
  color: #ffffff;
  font-weight: 900;
  letter-spacing: 0.1em;
  
}
.method_item{
  width: calc(100% - 4vh);
  font-size: 2.1vh;
  color: #e0dddd;
  text-align: left;

  line-height: 1.5;
}
.method_item2{
 
  font-size: 2.1vh;
  color: #e0dddd;
  text-align: left;

  line-height: 1.5;
}
.method_item3{ 
  font-size: 2.5vh;
  color: #e0dddd;
  text-align: left;
  line-height: 1.5;
  
}
</style>